import { render, staticRenderFns } from "./土地信息详情.vue?vue&type=template&id=4cf4134c&scoped=true"
import script from "./土地信息详情.vue?vue&type=script&lang=js"
export * from "./土地信息详情.vue?vue&type=script&lang=js"
import style0 from "./土地信息详情.vue?vue&type=style&index=0&id=4cf4134c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf4134c",
  null
  
)

export default component.exports